export default "__VITE_ASSET__DoBN0Mvm__"